module.exports = __webpack_public_path__ + "img/page-background.5ed14182.png";